import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';

export const timestampStyle = style({
  paddingLeft: TabStyles.Spacing.SmallSpace,
  paddingRight: TabStyles.Spacing.SmallSpace,
});

export const viewActivityLinkContainer = style({
  paddingTop: TabStyles.Spacing.DefaultSpace,
  paddingBottom: TabStyles.Spacing.MediumSpace
});

export const syncAllGroupsButtonContainer = style({
  paddingTop: TabStyles.Spacing.DefaultSpace,
  paddingBottom: TabStyles.Spacing.MediumSpace
});